import type { ExplicitAddress } from '@cronos-app/sdk';
import {
  ChainId,
  ChainLayer,
  getContractAddress,
  NeverError,
} from '@cronos-app/sdk';

export const EXTERNAL_LINK = {
  gitbook: 'https://agentfun.gitbook.io/',
  gitbookHowToDescribe:
    'https://agentfun.gitbook.io/home/how-it-works/create-ai-agent#some-tips-on-how-to-best-craft-a-description-for-an-agent',
  twitter: 'https://x.com/agentfunai',
  discord: 'http://discord.gg/aujevSAF6p',
  h2Swap(
    outputTokenAddress?: ExplicitAddress | null,
    inputTokenAddress?: ExplicitAddress | null,
  ) {
    const outputParam = outputTokenAddress
      ? `outputCurrency=${outputTokenAddress}`
      : '';
    const inputParam = inputTokenAddress
      ? `inputCurrency=${inputTokenAddress}`
      : '';
    const queryParams = [outputParam, inputParam].filter(Boolean).join('&');
    return `https://h2.finance/swap${queryParams ? `?${queryParams}` : ''}`;
  },
  h2SwapAgentFun: `https://h2.finance/swap?outputCurrency=${getContractAddress(
    ChainId.CRONOS_ZK_MAINNET,
    'AgentFun',
  )}`,
  vvsSwap(
    outputTokenAddress?: ExplicitAddress | null,
    inputTokenAddress?: ExplicitAddress | null,
  ) {
    const outputParam = outputTokenAddress
      ? `outputCurrency=${outputTokenAddress}`
      : '';
    const inputParam = inputTokenAddress
      ? `inputCurrency=${inputTokenAddress}`
      : '';
    const queryParams = [outputParam, inputParam].filter(Boolean).join('&');
    return `https://vvs.finance/swap${queryParams ? `?${queryParams}` : ''}`;
  },
  vvsSwapAgentFun: `https://vvs.finance/swap?outputCurrency=${getContractAddress(
    ChainId.CRONOS_EVM_MAINNET,
    'AgentFun',
  )}`,
  swapAgentToken: (
    layer: ChainLayer,
    tokenAddress?: ExplicitAddress | null,
  ) => {
    if (layer === ChainLayer.L2) {
      return EXTERNAL_LINK.h2Swap(
        tokenAddress,
        getContractAddress(ChainId.CRONOS_ZK_MAINNET, 'AgentFun'),
      );
    }
    if (layer === ChainLayer.CronosEvm) {
      return EXTERNAL_LINK.vvsSwap(
        tokenAddress,
        getContractAddress(ChainId.CRONOS_EVM_MAINNET, 'AgentFun'),
      );
    }
    throw NeverError(layer);
  },
  swapAgentFun: (layer: ChainLayer) => {
    if (layer === ChainLayer.L2) {
      return EXTERNAL_LINK.h2SwapAgentFun;
    }
    if (layer === ChainLayer.CronosEvm) {
      return EXTERNAL_LINK.vvsSwapAgentFun;
    }
    throw NeverError(layer);
  },
} as const;
